import script from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"
export * from "./Common-resource-list.vue?vue&type=script&setup=true&lang=js"

import "./Common-resource-list.vue?vue&type=style&index=0&id=d8131cfe&lang=scss&scoped=true"
import "./Common-resource-list.vue?vue&type=style&index=1&id=d8131cfe&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8131cfe"]])

export default __exports__